import React from 'react';
import { Link } from 'react-router-dom';
import { HiCalendar, HiArrowRight } from 'react-icons/hi';

const ArticleCard = ({ blog }) => {
  // Helper function to convert YouTube watch links to embed links
  const getEmbedUrl = (url) => {
    if (!url) return '';
    try {
      const urlObj = new URL(url);
      // Check for standard YouTube links
      if (urlObj.hostname.includes('youtube.com') && urlObj.searchParams.has('v')) {
        const videoId = urlObj.searchParams.get('v');
        return `https://www.youtube.com/embed/${videoId}`;
      }

      // Check for shortened youtu.be links
      if (urlObj.hostname.includes('youtu.be')) {
        const videoId = urlObj.pathname.slice(1);
        return `https://www.youtube.com/embed/${videoId}`;
      }
    } catch (error) {
      console.error("Invalid URL for video embed:", error);
      return ''; // Return empty string on error
    }
    // Return the original URL if it's not a recognizable YouTube link (e.g., Vimeo)
    return url;
  };

  const videoEmbedUrl = getEmbedUrl(blog.video_link);

  return (
    <div key={blog._id} className="group relative bg-gradient-to-br from-gray-800 to-slate-900 p-6 rounded-lg shadow-lg text-white overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-1">
      
      {/* Conditionally render PDF badge */}
      {blog.pdf_drive_link && (
        <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg shadow-lg z-10">
          PDF
        </div>
      )}
      
      {/* Conditionally render Video Iframe or Image */}
      {videoEmbedUrl ? (
        <div className="aspect-video w-full overflow-hidden rounded-md mb-4">
          <iframe
            src={videoEmbedUrl}
            title={blog.title}
            className="w-full h-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      ) : blog.image ? (
        <div className="overflow-hidden rounded-md mb-4">
          <img
            src={blog.image}
            alt={blog.title}
            className="w-full h-56 object-cover rounded-md transition-transform duration-500 group-hover:scale-110"
          />
        </div>
      ) : null}
      
      <h2 className="text-2xl font-bold mb-2 line-clamp-2">{blog.title}</h2>
      
      <p className="flex items-center gap-2 text-sm text-gray-400 mb-4">
        <HiCalendar />
        <span>{new Date(blog.created_at).toLocaleDateString()}</span>
      </p>
      
      <Link 
        to={`/blog/${blog.id}`} 
        className="inline-flex items-center gap-2 text-blue-400 font-semibold group-hover:text-blue-300 transition-colors"
      >
        <span>Read More</span>
        <HiArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
      </Link>
    </div>
  );
};

export default ArticleCard;